import { IconProps } from './icons-props';

function DateCategoryIcon({ className, width = 20, height = 20 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M16.6667 12.2917C15.4 12.2917 14.375 11.2667 14.375 10C14.375 8.73337 15.4 7.70837 16.6667 7.70837C17.9333 7.70837 18.9583 8.73337 18.9583 10C18.9583 11.2667 17.9333 12.2917 16.6667 12.2917ZM16.6667 8.95837C16.0917 8.95837 15.625 9.42504 15.625 10C15.625 10.575 16.0917 11.0417 16.6667 11.0417C17.2417 11.0417 17.7083 10.575 17.7083 10C17.7083 9.42504 17.2417 8.95837 16.6667 8.95837Z'
                fill='white'
            />
            <path
                d='M16.6667 5.62496C15.4 5.62496 14.375 4.59996 14.375 3.33329C14.375 2.06663 15.4 1.04163 16.6667 1.04163C17.9333 1.04163 18.9583 2.06663 18.9583 3.33329C18.9583 4.59996 17.9333 5.62496 16.6667 5.62496ZM16.6667 2.29163C16.0917 2.29163 15.625 2.75829 15.625 3.33329C15.625 3.90829 16.0917 4.37496 16.6667 4.37496C17.2417 4.37496 17.7083 3.90829 17.7083 3.33329C17.7083 2.75829 17.2417 2.29163 16.6667 2.29163Z'
                fill='white'
            />
            <path
                d='M16.6667 18.9583C15.4 18.9583 14.375 17.9333 14.375 16.6667C14.375 15.4 15.4 14.375 16.6667 14.375C17.9333 14.375 18.9583 15.4 18.9583 16.6667C18.9583 17.9333 17.9333 18.9583 16.6667 18.9583ZM16.6667 15.625C16.0917 15.625 15.625 16.0917 15.625 16.6667C15.625 17.2417 16.0917 17.7083 16.6667 17.7083C17.2417 17.7083 17.7083 17.2417 17.7083 16.6667C17.7083 16.0917 17.2417 15.625 16.6667 15.625Z'
                fill='white'
            />
            <path
                d='M3.33341 12.2917C2.06675 12.2917 1.04175 11.2667 1.04175 10C1.04175 8.73337 2.06675 7.70837 3.33341 7.70837C4.60008 7.70837 5.62508 8.73337 5.62508 10C5.62508 11.2667 4.60008 12.2917 3.33341 12.2917ZM3.33341 8.95837C2.75841 8.95837 2.29175 9.42504 2.29175 10C2.29175 10.575 2.75841 11.0417 3.33341 11.0417C3.90841 11.0417 4.37508 10.575 4.37508 10C4.37508 9.42504 3.90841 8.95837 3.33341 8.95837Z'
                fill='white'
            />
            <path
                d='M15 10.625H5C4.65833 10.625 4.375 10.3417 4.375 10C4.375 9.65833 4.65833 9.375 5 9.375H15C15.3417 9.375 15.625 9.65833 15.625 10C15.625 10.3417 15.3417 10.625 15 10.625Z'
                fill='white'
            />
            <path
                d='M15.0001 17.2917H11.6667C9.65008 17.2917 8.54175 16.1834 8.54175 14.1667V5.83337C8.54175 3.81671 9.65008 2.70837 11.6667 2.70837H15.0001C15.3417 2.70837 15.6251 2.99171 15.6251 3.33337C15.6251 3.67504 15.3417 3.95837 15.0001 3.95837H11.6667C10.3501 3.95837 9.79175 4.51671 9.79175 5.83337V14.1667C9.79175 15.4834 10.3501 16.0417 11.6667 16.0417H15.0001C15.3417 16.0417 15.6251 16.325 15.6251 16.6667C15.6251 17.0084 15.3417 17.2917 15.0001 17.2917Z'
                fill='white'
            />
        </svg>
    );
}

export default DateCategoryIcon;

